import { useEffect, useState } from 'react';
import { Modal } from '@mantine/core';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import FacebookAudienceInfo from '../Facebook/FacebookAudienceInfo';
import GoogleAudienceInfo from '../Google/GoogleAudienceInfo';
import Spinner from '../Spinner';

const AudienceInfoModal = ({ show, close, externalId, type }) => {
  const [info, setInfo] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const { accountId, domainId } = useParams();
  const fetch = useFetch();

  useEffect(() => {
    if (show && externalId && type) {
      const id = type === 'facebook' ? externalId : externalId.split('/')[3];
      setLoading(true);
      setError(null);
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segmentSyncs/audienceInfo/${type}/${id}`)
        .then(({ info }) => {
          setInfo(info);
        })
        .catch(({ message }) => {
          setError(message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [show, externalId, accountId, domainId, fetch, type]);

  return (
    <Modal size="lg" opened={show} onClose={close} title="Audience Information">
      {loading || !info ? (
        <Spinner />
      ) : type === 'facebook' ? (
        <FacebookAudienceInfo statuses={{ audience: { info } }} />
      ) : (
        <GoogleAudienceInfo info={info} />
      )}
      {error && <ErrorMessage message={error} />}
    </Modal>
  );
};

export default AudienceInfoModal;
